import _sortBy from "lodash/sortBy";

import type { AppDispatch, RootState } from "@redux/store";

import * as actionTypes from "@redux/navPoint/actionTypes";
import { getSection } from "@redux/selectors/getters";

export const sortSectionItems =
  (sectionIds: string[]) => (dispatch: AppDispatch, getState: () => RootState) => {
    const state = getState();

    const storeItems = state.entities.items.objects;

    const sections = sectionIds.reduce((acc, sId) => {
      const section = getSection(state, {
        identifier: sId,
        version: 0,
      });

      acc[`${section.id}-0`] = {
        items: _sortBy(section.items, [itemId => storeItems[itemId].displayOrder]),
      };
      return acc;
    }, {});
    return dispatch({
      type: actionTypes.SORT_SECTION_ITEMS,
      sections,
    });
  };
